<script setup>

import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const getLogoSizeBasedOnLayout = computed(() => {
    const layout = portalContentAndDesignStore.portalLayoutSettings.portal_layout;
    const logoSize = portalContentAndDesignStore.portalLayoutSettings.portal_layout_logo_size;

    if (layout === 'three') {
        switch (logoSize) {
            case 'max-h-4':
                return 'max-h-6';
            case 'max-h-6':
                return 'max-h-8';
            case 'max-h-8':
                return 'max-h-10';
            case 'max-h-10':
                return 'max-h-12';
            default:
                return 'max-h-8';
        }
    }

    return logoSize;
});

</script>

<template>
    <a v-if="portalContentAndDesignStore.srcRoutes.portal_layout_file_logo"
       :href="portalContentAndDesignStore.getHomeRoute"
       class="flex justify-start items-center mr-12"
    >
        <img
            :src="portalContentAndDesignStore.srcRoutes.portal_layout_file_logo"
            :class="['w-auto h-auto', getLogoSizeBasedOnLayout]"
        />
    </a>
</template>
